import HeaderLogo from "./headerLogo.svg";
import Document from "./document.svg";
import Phone from "./phone.svg";
import Car from "./car.svg";
import InfoCircle from "./infoCircle.svg";
import Close from "./close.svg";
import Replay from "./replay.svg";
import Timer from "./timer.svg";
import Alert from "./alert.svg";
import Pen from "./pen.svg";
import RedAlert from "./redAlert.svg";
import Home from "./home.svg";
import Location from "./location.svg";
import RedHome from "./redHome.svg";
import Star from "./star.svg";
import ChevronDown from "./chevronDown.svg";
import Checkbox from "./checkbox.svg";
import Speed from "./speed.svg";
import ChevronDownRed from "./chevron-down-red.svg";
import Celebrate from "./celebrate.svg";
import Acceleration from "./acceleration.svg";
import RedDocument from "./red-document.svg";
import RedLoan from "./red-loan.svg";
import RedPhone from "./red-phone.svg";
import RedLocation from "./red-location.svg";
import RedPriceTag from "./red-price-tag.svg";
import PopOut from "./pop-out.svg";
import ChevronUp from "./chevron-up.svg";
import GreenLeaf from "./green-leaf.svg";
import RedCircleAlert from "./redCircleAlert.svg";
import CloseBorderless from "./close-borderless.svg";
import RedRouter from "./red-router.svg";
import RedCampaign from "./red-campaign.svg";
import RedSpeed from "./red-speed.svg";
import RedSimCard from "./red-simcard.svg";
import RedTV from "./red-tv.svg";
import RedNetwork from "./red-network.svg";
import RedDataShare from "./red-data-share.svg";
import RedSaving from "./red-saving.svg";
import RedCalendar from "./red-calendar.svg";
import RedDeal from "./red-deal.svg";
import RedLogo from "./red-logo.png";
import AcceleroMeter from "./accelerometer.svg";
import MobilePhone from "./mobilePhone.svg";
import rAcceleration from "./9reason/acceleration.svg";
import rSimCard from "./9reason/simcard.svg";
import rCalendar from "./9reason/calendar.svg";
import rDeals from "./9reason/deals.svg";
import rDataShare from "./9reason/datatransfer.svg";
import rNetworkTower from "./9reason/networktower.svg";
import rSaving from "./9reason/saving.svg";
import rLocation from "./9reason/location.svg";
import Clock from "./icon-clock.png";
import Payment from "./icon-make-payment.png";
import RouterIcon from "./icon-router.png";
import DesktopPromo from "./desktop-promo.svg";
import MobilePromo from "./mobile-promo.svg";
import LeftConfeti from "./left-confeti.svg";
import RightConfeti from "./right-confeti.svg";
import MobileConfeti from "./mobile-confeti.svg";
import autoLoginImg from "./autologinImg.svg";
import Cross from "./cross.svg";
import BackArrow from "./arrow-left.svg";
import TOD from "./tod.svg";
import BluTV from "./blutv.svg";
import GamePass from "./gamepass.svg";
import HŞY from "./hşy.svg";
import ChevronRight from "../images/chevronRight.svg";
import ChevronLeft from "./chevronLeft.svg";
import ChevronUpRed from "./ChevronUpRed.svg";
import Signal from "./Signal.svg";
import Magic from "./Magic.svg";
import Coins from "./Coins.svg";
import LoadingGif from "./loadingGif.gif";
import oneClickLogo from "./oneclicklogo.png";
import editIcon from "./edit.svg"
import Quit from "./quit.svg"
import modemIMG from "./modemIMG.svg";
import VFSPM from "./VFSPM.svg";
import Exit from "./exit.svg";
import Error from "./Content.svg"
import ArrowLeft from "./arrow_left.svg"
import PhoneIcon from "./Dark-bkgd.svg"
import LocationIcon from "./locationIcon.svg"
import AlertIcon from "./Shape.svg"
import Info from "./Vector.svg"
import Tebrikler from "./tebrik.svg"
import Reward from "./gift.svg"
import Etiket from "./etiket.png"
import YeniModemBanner from "./modem-yeni-banner.svg"
import YeniModemBannerMobile from "./modem-yeni-banner-mobile.svg"
import BeyazChevron from "./beyaz-chevron.svg"
import Router from "./router.svg"
import CloseX from "./close-x.svg"
import HediyePaketi from "./all-rewards.svg"
import BannerRightImage from "./image-m.svg"
import DesktopLinkatİl from "./desktop-linkat-ill.svg"
import InfoWhite from "./infowhite.svg"
import SadTobi from "./tobi-sad.svg"
import Mail from "./mail.svg"
import Tel from "./tel.svg"
import WhiteAlert from "./whiteAlert.svg"
import Tobi from "./tobi.svg"
import Tick from "./tick.svg"
import EvWifi from "./evWifi.svg"
export {
  EvWifi,
  ChevronLeft,
  Tick,
  Tobi,
  WhiteAlert,
  Tel,
  Mail,
  SadTobi,
  Tebrikler,
  Info,
  AlertIcon,
  LocationIcon,
  PhoneIcon,
  ArrowLeft,
  Error,
  Exit,
  Quit,
  editIcon,
  oneClickLogo,
  Signal,
  Magic,
  Coins,
  HeaderLogo,
  ChevronUpRed,
  Document,
  Phone,
  Car,
  InfoCircle,
  Close,
  Replay,
  Timer,
  Alert,
  Pen,
  RedAlert,
  Home,
  Location,
  RedHome,
  Star,
  ChevronDown,
  Checkbox,
  Speed,
  ChevronDownRed,
  Celebrate,
  Acceleration,
  RedDocument,
  RedLoan,
  RedLocation,
  RedPhone,
  RedPriceTag,
  PopOut,
  ChevronUp,
  GreenLeaf,
  RedCircleAlert,
  CloseBorderless,
  RedRouter,
  RedCampaign,
  RedSpeed,
  RedSimCard,
  RedTV,
  RedNetwork,
  RedDataShare,
  RedSaving,
  RedCalendar,
  RedDeal,
  RedLogo,
  AcceleroMeter,
  MobilePhone,
  rAcceleration,
  rSimCard,
  rCalendar,
  rDeals,
  rDataShare,
  rNetworkTower,
  rSaving,
  rLocation,
  Clock,
  Payment,
  RouterIcon,
  DesktopPromo,
  MobilePromo,
  LeftConfeti,
  RightConfeti,
  MobileConfeti,
  autoLoginImg,
  Cross,
  BackArrow,
  TOD,
  GamePass,
  BluTV,
  HŞY,
  ChevronRight,
  LoadingGif,
  modemIMG,
  VFSPM,
  Reward,
  Etiket,
  YeniModemBanner,
  YeniModemBannerMobile,
  BeyazChevron,
  Router,
  CloseX,
  HediyePaketi,
  BannerRightImage,
  DesktopLinkatİl,
  InfoWhite
};
